module.exports = __webpack_public_path__ + "static/media/WATCH-BNB.6cd140d8.svg";